const GET_BILLING_RETAINERS_REQUEST = 'GET_BILLING_RETAINERS_REQUEST';
const SAVE_BILLING_RETAINER_TERMS_REQUEST = 'SAVE_BILLING_RETAINER_TERMS_REQUEST';
const GET_RETAINER_STATUS_REQUEST = 'GET_RETAINER_STATUS_REQUEST';

export const getBillingRetainers = (callback) => ({
    type: GET_BILLING_RETAINERS_REQUEST,
    payload: { callback }
});

export const saveBillingRetainerTerms = (entityType, entityId, billingTerms, callback) => ({
    type: SAVE_BILLING_RETAINER_TERMS_REQUEST,
    payload: { entityType, entityId, billingTerms, callback }
});

export const getRetainerStatus = ({ accountId, clientId }, callback) => ({
    type: GET_RETAINER_STATUS_REQUEST,
    payload: { accountId, clientId, callback }
});
